function optimizelyEvent(eventName, variantName, values = {}) {
    var _a, _b;
    /* eslint-disable */
    (_b = (_a = window.optimizely) === null || _a === void 0 ? void 0 : _a.push) === null || _b === void 0 ? void 0 : _b.call(_a, { type: 'event', eventName: eventName, tags: Object.assign({ title: variantName }, values) });
    /* eslint-enable */
}
export const trackImpression = (track, variant) => {
    track.impression({
        label: 'edit-button-labels-for-anon-desktop-impression',
    });
    optimizelyEvent('edit-button-labels-for-anon-desktop-impression', variant);
};
export const attachTrackParagraphsEditButtons = (variant) => {
    document.querySelectorAll('.mw-editsection-visualeditor').forEach((editButton) => {
        var _a;
        const trackingLabel = editButton.getAttribute('data-tracking-label');
        if (!trackingLabel) {
            return;
        }
        const parentHeaderType = (_a = editButton.closest('h2, h3, h4, h5, h6')) === null || _a === void 0 ? void 0 : _a.tagName;
        editButton.addEventListener('click', () => {
            optimizelyEvent('edit-button-labels-edit-paragraphs-click', variant, { header: `header-${parentHeaderType}` });
        });
    });
};
export const attachTrackPageSideTools = (variant) => {
    const pageSideTools = document.querySelector('#log-in-edit-side-tool');
    if (pageSideTools) {
        pageSideTools.addEventListener('click', () => {
            optimizelyEvent('edit-button-labels-side-edit-click', variant);
        });
    }
};
export const attachTrackEditButton = (variant) => {
    const editButton = document.querySelector('#log-in-edit');
    if (editButton) {
        editButton.addEventListener('click', () => {
            optimizelyEvent('edit-button-labels-edit-click', variant);
        });
    }
};
